$(document).ready(function() {
  eventosSliderNosotros();
});


// SLIDES NOSOTROS
const eventosSliderNosotros = () => {
  $('#carouselNosotros03').on('slide.bs.carousel', function onSlide (ev) {
    const id = ev.relatedTarget.id;
    // console.log(id) 
    // console.log(ev.direction)
  
    switch (id) {
      case "slide-nosotros-02":
        $('.section-nosotros-psa-03').removeClass('active-slide-01 active-slide-03')
        $('.section-nosotros-psa-03').addClass('active-slide-02')
        break;
      case "slide-nosotros-03":
        $('.section-nosotros-psa-03').removeClass('active-slide-01 active-slide-02')
        $('.section-nosotros-psa-03').addClass('active-slide-03')
        break;
      default:
        $('.section-nosotros-psa-03').removeClass('active-slide-02 active-slide-03')
        $('.section-nosotros-psa-03').addClass('active-slide-01')
        break;
    }
  })
}